import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\GetScreenListDossierByLocationController::__invoke
* @see app/Http/Controllers/Screen/GetScreenListDossierByLocationController.php
* @route '/api/screen/data/get-list-dossiers-by-location'
*/
const GetScreenListDossierByLocationController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenListDossierByLocationController.url(options),
    method: 'get',
})

GetScreenListDossierByLocationController.definition = {
    methods: ["get","head"],
    url: '/api/screen/data/get-list-dossiers-by-location',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Screen\GetScreenListDossierByLocationController::__invoke
* @see app/Http/Controllers/Screen/GetScreenListDossierByLocationController.php
* @route '/api/screen/data/get-list-dossiers-by-location'
*/
GetScreenListDossierByLocationController.url = (options?: RouteQueryOptions) => {
    return GetScreenListDossierByLocationController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\GetScreenListDossierByLocationController::__invoke
* @see app/Http/Controllers/Screen/GetScreenListDossierByLocationController.php
* @route '/api/screen/data/get-list-dossiers-by-location'
*/
GetScreenListDossierByLocationController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenListDossierByLocationController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Screen\GetScreenListDossierByLocationController::__invoke
* @see app/Http/Controllers/Screen/GetScreenListDossierByLocationController.php
* @route '/api/screen/data/get-list-dossiers-by-location'
*/
GetScreenListDossierByLocationController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetScreenListDossierByLocationController.url(options),
    method: 'head',
})

export default GetScreenListDossierByLocationController